import { z } from "zod";

import { BackendEntityType } from "./AttachmentModel";
import { baseCreateType } from "./CreateTypes";
import { InvitationStatus } from "./Invitation";
import { mediaModelResolver } from "./MediaModel";

export const documentFileResolver = z.object({
	id: z.string(),
	variants: mediaModelResolver.array()
});

export type DocumentFileModel = z.infer<typeof documentFileResolver>;

export const dataExportResolver = z.object({
	id: z.string(),
	entityId: z.string(),
	entityType: z.nativeEnum(BackendEntityType),
	dataType: z.string(),
	status: z.nativeEnum(InvitationStatus),
	generatedAt: z.string().nullable(),
	file: documentFileResolver.nullable(),
	entityInfo: baseCreateType.pick({ id: true, name: true, logo: true }).nullable()
});

export type DataExportModel = z.infer<typeof dataExportResolver>;
